if (!customElements.get("nss-accordion")) {
    customElements.define("nss-accordion", class NSSAccordion extends HTMLElement {
        constructor() {
            super();
            this.selectors = {
                toggle: ".js-nss-accordion-toggle",
                content: ".js-nss-accordion-panel"
            };

            this.toggles = this.querySelectorAll(this.selectors.toggle);
            this.contents = this.querySelectorAll(this.selectors.content);
        }

        connectedCallback() {
            this.toggles.forEach(el => {
                el.addEventListener('click', () => {
                    this.handleToggleClick(el);
                });
            });
        }


        handleToggleClick(toggle) {
            const isExpanded = toggle.getAttribute('aria-expanded') === 'true';
            const contentId = toggle.getAttribute('aria-controls');
            const content = this.querySelector(`#${contentId}`);

            // Collapse all toggles and panels
            this.resetAccordion();

            // Expand the clicked toggle and its corresponding content if it was not already expanded
            if (!isExpanded) {
                toggle.setAttribute('aria-expanded', 'true');
                content.classList.add('is-open');
                toggle.parentNode.classList.add('is-open');
            }
        }

        resetAccordion() {
            // Collapse all toggles and panels
            this.toggles.forEach(toggle => {
                    toggle.setAttribute('aria-expanded', 'false');
                    toggle.parentNode.classList.remove('is-open');
                }
            );
            this.contents.forEach(content =>
                content.classList.remove('is-open')
            );
        }
    });
}